module.exports = __webpack_public_path__ + "static/media/GALAD Контур LED.f13487ef.jpg";